import { MilitaryToMeridianPipe } from "../_pipes/military-to-meridian.pipe";
import { BrandModel } from "./brand.model";
import { CategoryModel } from "./category.model";
import { InformationModel } from "./information.model";
import { SettingModel } from "./setting.model";

const militaryToMeridian = new MilitaryToMeridianPipe()
export class BusinessEntityModel {

  id: string;
  name: string;
  url: string;
  brand: BrandModel
  information: InformationModel
  settings: SettingModel
  is_open: boolean
  today: string
  categories: CategoryModel[]

  constructor(obj: any = null) {
    this.id = obj?.id
    this.name = obj?.name
    this.url = obj?.url
    this.brand = new BrandModel(obj?.brand)
    this.information = new InformationModel(obj?.information)
    this.settings = new SettingModel(obj?.settings)
    this.is_open = obj?.is_open
    this.today = obj?.today
    this.categories = obj?.categories ? obj?.categories.map((i: any) => (new CategoryModel(i))) : []
  }

  get scheduleToday() {
    const weekDay = this.information?.schedule?.[this.today]

    if (weekDay?.is_24_hours && !weekDay?.label && this.is_open) {
      return 'Abierto 24 horas'
    }

    if (weekDay?.label && this.is_open) {
      return weekDay.label
    }

    if (!weekDay?.label && !weekDay?.is_24_hours && weekDay?.open && this.is_open) {
      return `de ${militaryToMeridian.transform(weekDay.open)} a ${militaryToMeridian.transform(weekDay.close)}`
    }

    if (!this.is_open) {
      return 'El comercio se encuentra cerrado'
    }

    return ''
  }

}

